import type {RouteRecordRaw} from "vue-router";

import {EPermissao} from "@/core/type/permissao.type";

export const lancamentoRoutes: RouteRecordRaw[] = [
    {
        path: "/lancamento",
        name: "lancamento",
        meta: {authRequired: true, permissao: EPermissao.CGR_PRISMA_LISTAR_LANCAMENTOS},
        component: () => import("@/modules/lancamento/pages/PageLancamento.vue")
    },
];
